import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const CreateDefectivo = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.post(`/defectivos`, params, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    crearDefectivoMutation: mutation.mutate,
  };
}

export const GetAllDefectivos = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/defectivos`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getAllDefectivosMutation: mutation.mutate,
  };
}

export const GetDefectivosByAlmacen = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.get(`/defectivos/almacen/${params}`);
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    getDefectivosByAlmacenMutation: mutation.mutate,
  };
}

export const ActualizarDefectivo = () => {
  const api = useApi();

  const mutate = async (params) => {
    const data = await api.put(`/defectivos/${params.id}`, params.body, {
      dataType: "json",
      hasFormData: false,
      hasCustomUrl: false,
    });
    return data.data;
  };

  const mutation = useMutation(mutate);

  return {
    actualizarDefectivoMutation: mutation.mutate,
  };
}